export default __webpack_public_path__ + "static/Download-App-3714dbf3acee34e6dfd48af8eb77d9a7.mp4";